import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductModulesBody } from "../productModulesBody";

/**
 * sealy ProductDisplayPage `modules` body assembly (#33590); see
 * `productModulesBody.tsx` for the dispatch map and side-channel design.
 *
 * FAITHFUL port of the legacy `cms/product_display_page.html` body loop
 * (verified at git dev): `{% for block in self.modules %}{% if
 * block.block_type != "gallery_block" or block.block_type == "value_prop_bar"
 * %}{% include_block block %}{% endif %}{% endfor %}` -- the `{% if %}` is
 * true for every type EXCEPT `gallery_block` (the `or` arm is unreachable:
 * any `value_prop_bar` block already passes the first arm), so the ONLY
 * filtered type is top-level `gallery_block`, reproduced by the `.filter()`
 * below. No per-block Wagtail wrapper (bare include_block loop) ->
 * `tagName={React.Fragment}` inside ProductPageBody.
 */
export const ProductDisplayPageBody = (
    props: Immutable<
        Pick<
            templates.ProductDisplayPageTemplate,
            | "page"
            | "reviews"
            | "page_num_reviews"
            | "change_variant_ssr"
            | "change_root_ssr"
            | "root_conditional_ssr"
            | "variant_conditional_ssr"
            | "tab_cards_initial_root_product_id"
        >
    >,
): React.JSX.Element | null => {
    const modules = props.page.modules;
    if (!modules) {
        return null;
    }
    return (
        <ProductModulesBody
            value={modules.value.filter(
                (block) => block.type !== "gallery_block",
            )}
            reviews={props.reviews}
            pageNumReviews={props.page_num_reviews}
            changeVariantSSR={props.change_variant_ssr}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
            variantConditionalSSR={props.variant_conditional_ssr}
            tabCardsInitialRootProductID={
                props.tab_cards_initial_root_product_id
            }
        />
    );
};
